import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeoMenuModule } from '@neogov/pattern-library/neo-menu';
import { IconComponent } from '../../../icon/icon.component';

@Component({
  selector: 'cm-menu-item',
  standalone: true,
  imports: [CommonModule, NeoMenuModule, IconComponent],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.less',
})
export class MenuItemComponent {
  public readonly icon = input<string | undefined>(undefined);
  public readonly autId = input<string>('cm-menu-item');
  public readonly disabled = input<boolean>(false);

  public readonly hasIcon = () => !!this.icon();
}
